const capitalizeFirstLetter = (inputString) => {
  if (!inputString) {
    return inputString;
  }
  return `${inputString.charAt(0).toUpperCase()}${inputString.slice(1)}`;
};

export default capitalizeFirstLetter;
